import { useToasts, dismissToast } from './toast';

const toneClass: Record<string, string> = {
  info: 'border-tg-border-soft bg-tg-surface text-tg-text',
  success: 'border-tg-success/40 bg-tg-surface text-tg-text',
  error: 'border-tg-danger/40 bg-tg-surface text-tg-text',
};

export function ToastViewport() {
  const toasts = useToasts();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed inset-x-3 bottom-24 z-50 flex flex-col items-center gap-2 sm:inset-x-auto sm:right-5 sm:bottom-5"
      role="status"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border px-4 py-3 shadow-panel ${toneClass[toast.tone] ?? toneClass.info ?? ''}`}
        >
          <p className="flex-1 text-sm">{toast.message}</p>
          {toast.action !== undefined ? (
            <button
              type="button"
              className="shrink-0 rounded-lg border border-tg-accent/40 bg-tg-accent-soft px-2.5 py-1 text-xs font-medium text-tg-accent hover:bg-tg-accent/20"
              onClick={() => {
                toast.action?.onClick();
                dismissToast(toast.id);
              }}
            >
              {toast.action.label}
            </button>
          ) : null}
          <button
            type="button"
            className="text-tg-text-muted transition-colors hover:text-tg-text"
            onClick={() => {
              dismissToast(toast.id);
            }}
            aria-label="Закрыть уведомление"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
